module.exports = __webpack_public_path__ + "static/media/มะเมีย.36f3b111.jpg";